module.exports = __webpack_public_path__ + "static/media/Baked cheesecake.cb6f1438.jpg";